import React, {Component} from 'react';
import {injectIntl} from "react-intl";
import './LoginForm.css';
import SAInputLabel from "../../components/common/input/SAInputLabel";
import SAButton from "../../components/common/button/SAButton";

const RESET_PASSWORD_BMW = 'https://www.bmw-connecteddrive.com';
const RESET_PASSWORD_MINI = 'https://www.mini-connected.com';


class LoginForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            errors: {},
        };
    }

    getPasswordResetUrl = () => {
      const host = window.location.host;
      if (host.endsWith('mini.be') || host.endsWith('mini.lu')){
        return RESET_PASSWORD_MINI
      } else {
        return RESET_PASSWORD_BMW
      }
    }

  handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();

        const { username, password } = this.state;

        let errors = {};

        if (!username) {
            errors['username'] = {message: 'error.not.null'};
        }

        if (!password) {
            errors['password'] = {message: 'error.not.null'};
        }

        this.setState({errors: errors});

        if (Object.keys(errors).length === 0) {
          this.props.onSubmit(username, password);
        }
    };

    render() {
        const { intl:{formatMessage}, backendError, isSubmitting} = this.props;
        const { errors, username, password } = this.state;

      let formErrors = {};
      if (Object.keys(errors).length > 0) {
        formErrors = errors;
      } else {
        if (backendError && backendError.content) {
          formErrors = backendError.content;
        }
      }

        return (
            <form name="loginForm" onSubmit={this.handleSubmit}>
                <SAInputLabel
                         type="text"
                         name="username"
                         label={'cui.home.login.username'}
                         error={formErrors['username']}
                         value={username}
                         onChange={this.handleChange} />
                <SAInputLabel
                         type="password"
                         name="password"
                         label={'cui.home.login.password'}
                         error={formErrors['password']}
                         value={password}
                         onChange={this.handleChange} />

                <React.Fragment>
                  <a onClick={e=>window.open(this.getPasswordResetUrl())}>{formatMessage({id:'cui.home.login.forgot-password'})}</a>
                  <SAButton
                    type="primary"
                    htmlType="submit"
                    disabled={isSubmitting}>
                    {formatMessage({id:'cui.home.login.login-button'})}
                    </SAButton>
                </React.Fragment>
            </form>
        );
    }
}

export default injectIntl(LoginForm);
